import React from 'react'
import './MapTo.css'

export default function MapTo() {
  return (
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2362.212190577741!2d29.830467918567336!3d62.62551760382101!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469b87b461d54319%3A0x9dee78278d0acdad!2sSL%20Health!5e0!3m2!1sfi!2sfi!4v1692176849354!5m2!1sfi!2sfi" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" id='mapTo'></iframe>
  )
}
